import { viewerSlice } from "../entities/viewer/slice";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { applicationSlice } from "./model/applicationSlice";
import { usersSlice } from "@/entities/users/slice";
import { nomenclatureSlice } from "@/entities/product/slice";
import { ordersSlice } from "@/entities/order/slice";
import { cartSlice } from "@/entities/cart";
import { dealersSlice } from "@/entities/dealer";
import { reportsSlice } from "@/entities/report/slice";
import { brandsSlice } from "@/entities/brand/slice";
import { marginalitySlice } from "@/entities/marginality/slice";
import { receivableSlice } from "@/entities/accountsReceivable/slice";
import { dmsanalyticSlice } from "@/entities/dmsanalytic/slice";
import { recommendationSlice } from "@/entities/recommendation/slice";
import { faqSlice } from "@/entities/faq/slice";
import figureSettingsReducer from "@/entities/figureSettings/slice";

import imageServiceSlice from "@/entities/imageService/slice";

import { mailingSettings } from "@/entities/mailerSettings/slice";
import { monitoringSlice } from "@/entities/monitoring/slice";
import { stockPublicationSlice } from "@/entities/stockPublication";
import { dealerOrdersSlice } from "@/entities/dealerOrder/slice";

const rootReducer = combineReducers({
  app: applicationSlice.reducer,
  viewer: viewerSlice.reducer,
  users: usersSlice.reducer,
  nomenclature: nomenclatureSlice.reducer,
  orders: ordersSlice.reducer,
  dealerOrders: dealerOrdersSlice.reducer,
  cart: cartSlice.reducer,
  dealers: dealersSlice.reducer,
  reports: reportsSlice.reducer,
  brands: brandsSlice.reducer,
  marginality: marginalitySlice.reducer,
  accountsReceivable: receivableSlice.reducer,
  dmsanalytic: dmsanalyticSlice.reducer,
  recommendation: recommendationSlice.reducer,
  faq: faqSlice.reducer,
  imageService: imageServiceSlice.reducer,
  mailing: mailingSettings.reducer,
  monitoring: monitoringSlice.reducer,
  figureSettings: figureSettingsReducer.reducer,
  stockPublication: stockPublicationSlice.reducer,
});

// 2. Создайте функцию-фабрику
export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
};

// 3. Экспортируйте стандартный store для использования в приложении
export const store = setupStore();

// 4. Обновите типы
export type RootState = ReturnType<typeof rootReducer>; // Важно: берем от rootReducer
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
